var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    className: "___12fm75w f1w7gpdv fez10in fg4l7m0",
    "aria-hidden": "true",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 15.7a1 1 0 001.4 0L12 9.42l6.3 6.3a1 1 0 001.4-1.42l-7-7a1 1 0 00-1.4 0l-7 7a1 1 0 000 1.42z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronFilled);
export default __webpack_public_path__ + "static/media/ChevronFilled.620cb3b2e07e22891ff5a7d6ce63835b.svg";
export { ForwardRef as ReactComponent };